import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_company_employee_link_RowCLass} from '../../../dbschema/bl_fi_mst_company_employee_link.model';

export class CompanyEmployeeLinkContainer extends BaseContainerModel {
    bl_fi_mst_company_employee_link: bl_fi_mst_company_employee_link_RowCLass = new bl_fi_mst_company_employee_link_RowCLass();
}
